import React, { Component } from 'react';
import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import isoWeek from 'dayjs/plugin/isoWeek';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import isBetween from 'dayjs/plugin/isBetween';
import { Helmet } from 'react-helmet';
import 'reflect-metadata';
import { AppRouter } from './AppRouter';

import { unregister as unregisterServiceWorker } from './registerServiceWorker';
import { CommandPallet } from './components/commandPallette/CommandPallet';

dayjs.extend(weekOfYear);
dayjs.extend(weekday);
dayjs.extend(isoWeek);
dayjs.extend(advancedFormat);
dayjs.extend(isBetween);

unregisterServiceWorker();

class App extends Component {
  render(): JSX.Element {
    return (
      <>
        <Helmet>
          <title>Dispatch AWS</title>
        </Helmet>
        <CommandPallet />
        <AppRouter />
      </>
    );
  }
}

export default App;
